<template>
    <v-container class="px-0">
        <div v-if="showResult == false">
            <v-row justify="center">
                <h3>{{ $t('containsDescriptiveQuestions') }}</h3>
            </v-row>
        </div>
        <div v-else ref="quizResult">
            <v-row v-if="downloadVisible == true" justify="end" class="pr-3">
                <v-icon medium @click="generateResultPdf">picture_as_pdf</v-icon>
            </v-row>
            <v-row justify="center">
                <v-col cols="4" sm="3" md="2" class="font-weight-black">
                    <h3>{{ $t('resultSheet') }}</h3>
                </v-col>
            </v-row>
            <v-row class="pl-4">
                <v-col cols="12" sm="6" md="1">
                    <span class="font-weight-medium">{{ $t('student') }}</span>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                    <span>{{ this.name }}</span>
                </v-col>
                <v-col cols="12" sm="6" md="1">
                    <span class="font-weight-medium">{{ $t('email') }}</span>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                    <span>{{ this.email }}</span>
                </v-col>
                <v-col cols="12" sm="6" md="1">
                    <span class="font-weight-medium">{{ $t('title') }}</span>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                    <span>{{ this.quizTitle }}</span>
                </v-col>
            </v-row>
            <v-row class="pl-4">
                <v-col cols="12" sm="6" md="1">
                    <span class="font-weight-medium">{{ $t('timeTakenMin') }}</span>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                    <span>{{ this.timeTaken }} min</span>
                </v-col>
                <v-col cols="12" sm="6" md="1">
                    <span class="font-weight-medium">{{ $t('marks') }}</span>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                    <span>{{ this.quizMarks }}</span>
                </v-col>
                <v-col cols="12" sm="6" md="1">
                    <span class="font-weight-medium">{{ $t('marksObtained') }}</span>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                    <span>{{ this.marksObtained }}</span>
                </v-col>
            </v-row>
            <v-row class="pl-4">
                <v-col cols="12" sm="6" md="1">
                    <span class="font-weight-medium">{{ $t('totalPointerIncident') }}</span>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                    <span>{{ pointerLeaveCountSumExamine }}</span>
                </v-col>
                <v-col cols="12" sm="6" md="1">
                    <span class="font-weight-medium">{{ $t('totalExamWindowsLeft') }}</span>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                    <span>{{ visibilitychangeCountSumExamine }}</span>
                </v-col>
                <v-col cols="12" sm="6" md="1">
                    <span class="font-weight-medium">{{ $t('totalPenalty') }}</span>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                    <span>{{ totalPanalty }}</span>
                </v-col>
            </v-row>
            <v-data-table :headers="headersResult" :items="itemsResult" disable-pagination hide-default-footer>
                <template v-slot:[`item.webCamVideoPath`]="{ item }">
                    <v-tooltip
                        v-if="item.webCamVideoPath.includes('/Resources/QuestionVideos/') || item.webCamVideoPath.includes('amazonaws.com')"
                        top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon large v-bind="attrs" v-on="on" @click="playWebCamVideo(item.webCamVideoPath)">
                                {{ getMediaIconName(item.webCamVideoPath) }}
                            </v-icon>
                        </template>
                        <span v-if="item.webCamVideoPath.includes('.webm')">{{ $t('seeVideo') }}</span>
                        <span v-else>{{ $t('listenAudio') }}</span>
                    </v-tooltip>
                    <span v-else>n/a</span>
                </template>
                <template v-slot:[`item.userAnswer`]="{ item }">
                    <v-tooltip
                        v-if="item.userAnswer.includes('/Resources/QuestionVideos/') || item.userAnswer.includes('amazonaws.com')"
                        top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon large v-bind="attrs" v-on="on" @click="playWebCamVideo(item.userAnswer)">
                                {{ getMediaIconName(item.userAnswer) }}
                            </v-icon>
                        </template>
                        <span v-if="item.userAnswer.includes('.webm')">{{ $t('seeVideo') }}</span>
                        <span v-else>{{ $t('listenAudio') }}</span>
                    </v-tooltip>
                    <span v-else>{{ formatUserAnswer(item) }}</span>
                </template>
                <template v-slot:[`item.isAnswerSkipped`]="{ item }">
                    <span>{{ formatAnswerSkipped(item) }}</span>
                </template>
                <template v-slot:[`item.questionMark`]="{ item }">
                    <span>{{ formatQuestionMarks(item) }}</span>
                </template>
                <template v-slot:[`item.userObtainedQuestionMark`]="{ item }">
                    <span>{{ formatUserMarks(item) }}</span>
                </template>
                <template v-slot:[`item.correctAnswer`]="{ item }">
                    <span>{{ formatCorrectAnswer(item) }}</span>
                </template>
            </v-data-table>
        </div>
        <v-dialog v-if="resetPlayer == true" v-model="dialogVideo" @click:outside="closeVideoDialog" max-width="850">
            <video-player :options="videoOptions" />
        </v-dialog>
    </v-container>
</template>

<script>

import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import VideoPlayer from '../../components/player/VideoPlayer.vue'
import config from '../../../public/config'

export default {
    name: 'quizResult',
    components: {
        VideoPlayer
    },
    data() {
        return {
            previewUploadVideo: null,
            videoOptions: {
                autoplay: true,
                controls: true,
                sources: [
                    {
                        src: {},
                        type: 'video/mp4'
                    }
                ]
            },
            headers: [
                { text: this.$t('question'), value: 'questionDetail' },
                { text: 'Question Multimedia', value: 'webCamVideoPath' },
                { text: this.$t('yourAnswer'), value: 'userAnswer' },
                { text: 'Correct Answer', value: 'correctAnswer' },
                { text: this.$t('skipped'), value: 'isAnswerSkipped' },
                { text: this.$t('questionMarks'), value: 'questionMark' },
                { text: this.$t('yourMarks'), value: 'userObtainedQuestionMark' },
                { text: this.$t('pointerLeaveCount'), value: 'pointerLeaveCount' },
                { text: this.$t('visibilitychangeCount'), value: 'visibilitychangeCount' },
                { text: 'Answer Explanation', value: 'answerExplanation' },
            ],
            resetPlayer: false,
            hostUrl: null,
            webCamVideoUrl: '',
            dialogVideo: false,
            name: '',
            email: '',
            quizTitle: '',
            timeTaken: '',
            quizMarks: '',
            marksObtained: '',
            itemsResult: [],
            allowCorrectOption: null,
            allowAnswerExplation: null,
            isShownResult: false,
            visibilitychangeCountSum: 0,
            pointerLeaveCountSum: 0
        }
    },
    methods: {
        generateResultPdf() {
            var pdfRef = this.$refs.quizResult;
            html2canvas(pdfRef).then(canvas => {
                var imgData = canvas.toDataURL('image/png');
                var doc = new jsPDF({
                    orientation: 'p'
                });
                var imgWidth = 210;
                var pageHeight = 295;
                var imgHeight = canvas.height * imgWidth / canvas.width;
                var heightLeft = imgHeight;
                var position = 10;

                doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;

                while (heightLeft >= 0) {
                    position += heightLeft - imgHeight;
                    doc.addPage();
                    doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                    heightLeft -= pageHeight;
                }
                doc.save('Result.pdf');
            })
        },
        quizResult(id) {
            this.$store.dispatch('dashboard/applyLoading')
            this.$store.dispatch('dashboard/fetchFinishedExamInfo', id)
                .then((response) => {
                    if (response.status == 200) {
                        if (response.data.isExamined) {
                            this.isShownResult = true
                            this.$store.dispatch('dashboard/fetchFinishedExamResult', id)
                                .then((response) => {
                                    //console.log(response.data)
                                    this.itemsResult = response.data

                                    this.name = this.itemsResult[0].fullName
                                    this.email = this.itemsResult[0].email
                                    this.quizTitle = this.itemsResult[0].quizTitle
                                    this.timeTaken = this.itemsResult[0].timeTaken
                                    this.pointerLeaveCountSum = this.itemsResult[0].pointerLeaveCountSum
                                    this.visibilitychangeCountSum = this.itemsResult[0].visibilitychangeCountSum
                                    this.quizMarks = this.itemsResult[0].quizMark == 0 ? 'n/a' : this.itemsResult[0].quizMark
                                    this.marksObtained = this.itemsResult[0].quizMark == 0 ? 'n/a' : (this.itemsResult[0].userObtainedQuizMark > this.itemsResult[0].quizMark ? this.itemsResult[0].quizMark : this.itemsResult[0].userObtainedQuizMark)
                                })
                                .catch((err) => {
                                    console.log(err)
                                })
                        } else {
                            this.isShownResult = false
                        }
                    }
                    this.$store.dispatch('dashboard/cancelLoading')
                })
                .catch((err) => {
                    this.$router.push({ name: 'NoInternet' })
                    console.log(err)
                })
        },
        playWebCamVideo(item) {
            this.resetPlayer = true
            this.dialogVideo = true
            const cloudfrontBase = this.$store.getters['settings/allSettings'].cloudFrontBaseUrl;
            let cloudFrontUrl="";

            if (item.includes("amazonaws.com")) {
                const pathStartIndex = item.indexOf(".amazonaws.com") + ".amazonaws.com".length;
                const path = item.substring(pathStartIndex);
                cloudFrontUrl = cloudfrontBase + path;
            }
            this.previewUploadVideo = item.includes('amazonaws.com') ? cloudFrontUrl : this.hostUrl + item
            this.videoOptions.sources = { src: this.previewUploadVideo }
        },
        closeVideoDialog() {
            this.resetPlayer = false
            this.dialogVideo = false
        },
        formatUserAnswer(item) {
            return item.userAnswer
        },
        formatAnswerSkipped(item) {
            return item.isAnswerSkipped == true ? 'yes' : 'no'
        },
        formatQuestionMarks(item) {
            return item.questionMark == 0 ? 'n/a' : item.questionMark
        },
        formatUserMarks(item) {
            return item.questionMark == 0 ? 'n/a' : item.userObtainedQuestionMark
        },
        formatCorrectAnswer(item) {
            return item.correctAnswer != null ? item.correctAnswer.replace(/#####/g, ',') : ''
        },
        getMediaIconName(ref) {
            return ref.includes('.webm') ? 'videocam' : 'volume_up'
        }
    },
    computed: {
        headersResult() {
            return this.headers.filter((item) => {
                if (this.allowCorrectOption == false && this.allowAnswerExplation == false) {
                    return item.text != 'Correct Answer' && item.text != 'Answer Explanation'
                } else if (this.allowCorrectOption == false) {
                    return item.text != 'Correct Answer'
                } else if (this.allowAnswerExplation == false) {
                    return item.text != 'Answer Explanation'
                } else {
                    return item
                }
            })
        },
        downloadVisible() {
            return window.innerWidth >= 960 ? true : false
        },
        showResult() {
            return this.isShownResult
        },
        pointerLeaveCountSumExamine: function () {
            return this.pointerLeaveCountSum
        },
        visibilitychangeCountSumExamine: function () {
            return this.visibilitychangeCountSum
        },
        totalPanalty: function () {
            return this.visibilitychangeCountSum + this.pointerLeaveCountSum
        }
    },
    mounted() {
        if (this.$store.getters['dashboard/resultFlag'] == false) {
            this.$router.push({ name: 'Dashboard' })
        }
    },
    beforeDestroy() {
        this.$store.dispatch('dashboard/saveResultFlag', false)
    },
    created() {
        this.hostUrl = config.hostname
        if (this.$store.getters['dashboard/quiz'].allowExamOnNewWindow) {
            this.$store.dispatch('dashboard/changeVisibilityFalse')
        } else {
            this.$store.dispatch('dashboard/changeVisibility')
        }
        this.allowCorrectOption = this.$store.getters['dashboard/quiz'].allowCorrectOption
        this.allowAnswerExplation = this.$store.getters['dashboard/quiz'].allowAnswerExplation
        this.quizResult(this.$store.getters['dashboard/responseInitial'].quizResponseInitialId)
    }
}
</script>